import { render, staticRenderFns } from "./DiscountBarChart.vue?vue&type=template&id=25fec993&"
import script from "./DiscountBarChart.vue?vue&type=script&lang=js&"
export * from "./DiscountBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports